export default {
  REDUX_NAMESPACE: 'IULI/PAYABLES',

  SET_FILTER_COMPETENCY_DATE: 'PAYABLES/SET_FILTER_COMPETENCY_DATE',
  SET_FILTER_DUE_OR_PAYMENT_DATE: 'PAYABLES/SET_FILTER_DUE_OR_PAYMENT_DATE',
  SET_FILTER_COMPUTED_STATUS: 'PAYABLES/SET_FILTER_COMPUTED_STATUS',
  SET_FILTER_RECONCILED: 'PAYABLES/SET_FILTER_RECONCILED',
  SET_FILTER_SCHEDULED: 'PAYABLES/SET_FILTER_SCHEDULED',
  SET_FILTER_CATEGORY_ID: 'PAYABLES/SET_FILTER_CATEGORY_ID',
  SET_FILTER_CATEGORIES_IDS: 'PAYABLES/SET_FILTER_CATEGORIES_IDS',
  SET_FILTER_BANK_ACCOUNTS_IDS: 'PAYABLES/SET_FILTER_BANK_ACCOUNTS_IDS',
  SET_FILTER_SOURCES: 'PAYABLES/SET_FILTER_SOURCES',
  SET_FILTER_PROJECTS: 'PAYABLES/SET_FILTER_PROJECTS',
  SET_FILTER_COST_CENTERS: 'PAYABLES/SET_FILTER_COST_CENTERS',
  SET_FILTER_TRANSACTIONS_IDS: 'PAYABLES/SET_FILTER_TRANSACTIONS_IDS',
  SET_FILTER_EXTERNALS_IDS: 'PAYABLES/SET_FILTER_EXTERNALS_IDS',
  SET_FILTERS: 'PAYABLES/SET_FILTERS',

  SET_SORT_MODEL: 'PAYABLES/SET_SORT_MODEL',

  SET_PAGE_SIZE: 'PAYABLES/SET_PAGE_SIZE',

  SET_INITIAL_STATE: 'PAYABLES/SET_INITIAL_STATE',
};
